import React from 'react';
import { useTranslation } from 'react-i18next';
import { SourceDetails } from 'features/layout/types';
import { LOCAL_MUTE_ICONS } from 'features/local-mute/icons';
import {
  ClickCallback,
  useTileLocalMute,
} from 'features/streaming/components/controls/useTileLocalMute';

export const useLocalMuteControl = (source: SourceDetails, clickCallback: ClickCallback) => {
  const { t } = useTranslation('room');
  const { available, isMuted, toggleMute } = useTileLocalMute(source);

  return {
    show: available,
    icon: LOCAL_MUTE_ICONS.muteForMe,
    text: isMuted ? t('tooltips.unmute_for_me') : t('tooltips.mute_for_me'),
    onClick: (e: React.MouseEvent<HTMLButtonElement | HTMLLIElement, MouseEvent>) => {
      clickCallback?.(e);
      toggleMute();
    },
  };
};
